import { Config } from "@/utils/config.utils";
import { useScript } from "@/utils/hooks/useScript.hook";

type UseNeverbounceScriptProps = {
    disabled?: boolean;
};

const useNeverbounceScript = ({ disabled }: UseNeverbounceScriptProps) => {
    const { status } = useScript({
        src: "https://cdn.neverbounce.com/widget/dist/NeverBounce.js",
        id: "neverbounce",
        disabled: disabled,
        configFn: () => {
            if (!window._NBSettings) {
                window._NBSettings = {
                    apiKey: Config.integrations["neverbounce-api-key"],
                    apiOnly: true,
                    timeout: Number(
                        (
                            Config.integrations["neverbounce-timeout"] / 1000
                        ).toFixed(2)
                    )
                };
            }
        }
    });

    return status;
};

export { useNeverbounceScript };
